// Vendors
import {
  TrackingEventsEnumeration,
  TrackingLinkEventReturnType,
} from '@gruposantander/opbpay-ui-core-models';
// Constants
import {
  DROP_MODAL_COMPONENT,
  DROP_MODAL_EVENT_ACTION,
} from './constants/header-layout.tracking.handlers.constants';
// Types
import { HeaderLayoutTrackingHandlersReturnType } from './types/header-layout.handlers.type';
import { TrackBuilderType } from 'types/track-builder.type';

const trackClickBack = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'return',
    format: 'arrow',
    component: 'header',
    element: 'arrow',
    eventAction: 'clickArrow',
    eventLabel: 'returnArrow',
  },
  type: TrackingEventsEnumeration.LINK,
});

const trackCloseIcon = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'close',
    format: 'cross',
    component: DROP_MODAL_COMPONENT,
    element: 'cross',
    eventAction: DROP_MODAL_EVENT_ACTION,
    eventLabel: 'close',
  },
  type: TrackingEventsEnumeration.LINK,
});

const trackCancelButton = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'cancel',
    format: 'link',
    component: DROP_MODAL_COMPONENT,
    element: 'cancel',
    eventAction: DROP_MODAL_EVENT_ACTION,
    eventLabel: 'cancelLink',
  },
  type: TrackingEventsEnumeration.LINK,
});

const trackOpenModal = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'open',
    format: 'modal',
    component: DROP_MODAL_COMPONENT,
    element: 'full',
    eventAction: DROP_MODAL_EVENT_ACTION,
    eventLabel: 'open',
  },
  type: TrackingEventsEnumeration.LINK,
});

const HeaderLayoutTrackingHandlers = (
  track: TrackBuilderType
): HeaderLayoutTrackingHandlersReturnType => ({
  handleTrackClickBack: () => {
    track(trackClickBack());
  },
  handleTrackCloseIcon: () => track(trackCloseIcon()),
  handleTrackCancelButton: () => track(trackCancelButton()),
  handleTrackOpenModal: () => track(trackOpenModal()),
});

export { HeaderLayoutTrackingHandlers };
